import Stores from "../components/Stores/Stores.tsx";


const AdminDashboard: React.FC = () => {

  return (
    <>
    <Stores />
    </>

  );
};

export default AdminDashboard;
